import { PhoenixMetrics } from "@amzn/ads-phoenix-type-script-client";
import { Flex, Link, Text } from "@amzn/storm-ui";
import React, { useEffect, useState } from "react";
import { useStore } from "zustand";

import { TELEMETRY_ID, PHOENIX_FEATURE } from "../../constants/telemetry";
import { FeatureFlags, FeatureFlagsStore } from "../../store/featureFlags";
import { QueryParam } from "../../utils/permission.utils";
import { logWithTakt } from "../../utils/telemetry.utils";

interface UnifiedSearchToggleProps {
    className?: string;
}

export const UnifiedSearchToggle: React.FC<UnifiedSearchToggleProps> = ({
    className,
}) => {
    const [isUnifiedSearchEnabled] = useStore(FeatureFlagsStore, (state) => [
        state[FeatureFlags.UNIFIED_SEARCH],
    ]);

    const [isToggled, setIsToggled] = useState(isUnifiedSearchEnabled);

    useEffect(() => {
        setIsToggled(isUnifiedSearchEnabled);
    }, [isUnifiedSearchEnabled]);

    const handleLinkClick = (e: React.MouseEvent) => {
        e.preventDefault();

        logWithTakt(TELEMETRY_ID.REVERT_TO_LEGACY_EXPERIENCE);
        PhoenixMetrics.emit(
            TELEMETRY_ID.REVERT_TO_LEGACY_EXPERIENCE,
            PHOENIX_FEATURE.NAVIGATION,
        );

        // Update URL with the new feature flag value and reload the page
        const newFeatureFlagValue = !isToggled;

        const url = new URL(window.location.href);

        // Remove filter parameters to prevent carrying over filters between views
        url.searchParams.delete(QueryParam.FILTERS);
        url.searchParams.delete(QueryParam.UNIFIED_FILTERS);

        // Set the feature flag parameter
        url.searchParams.set(
            FeatureFlags.UNIFIED_SEARCH,
            newFeatureFlagValue.toString(),
        );

        window.location.href = url.toString();
    };

    const linkText = isToggled
        ? "Switch to legacy search experience"
        : "Switch to unified search experience";

    return (
        <Flex className={className} alignItems="center">
            <Text size="xsmall">
                <Link
                    href="#"
                    onClick={handleLinkClick}
                    data-testid="unified-search-link"
                >
                    {linkText}
                </Link>
            </Text>
        </Flex>
    );
};
